import React, { useState } from "react";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import DomainService from "../../services/DomainService";
import CustomYesNoModal from "../micro_components/CustomYesNoModal";
import NotificationModal from "../micro_components/NotificationModal";
import GroupsModal from "./GroupsModal";
import UsageDataModal from "./UsageDataModal"
import {
  AddUserToDomainModal,
  DeleteUserModal,
  UserDetailsModal,
} from "./DomainUserModals";

const DomainItem = ({ initialDomain, loadDomains, allFields }) => {
  const [domain, setDomain] = useState(initialDomain);
  const [isDropped, setIsDropped] = useState(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [changesSaved, setChangesSaved] = useState(false);
  //groups modal
  const [groupsModalOpen, setGroupsModalOpen] = useState(false);

  const [addUserModalOpen, setUserModalOpen] = useState(false);

  const [deleteUserModalOpen, setDeleteUserModalOpen] = useState(false);

  const [usageDataModalOpen, setUsageDataModalOpen] = useState(false)
  // const [fields, setFields] = useState(new Set());
  // const [newField, setNewField] = useState("");
  const [userDetailsModalOpen, setUserDetailsModalOpen] = useState(false);

  const arrowStyle = {
    transform: isDropped ? "rotate(90deg)" : "",
    transition: "transform 150ms ease", // smooth transition
  };

  const toggleDrop = () => {
    setIsDropped(!isDropped);
    console.log("drop");
  };

  const confirmDelete = () => {
    DomainService.remove(domain.id)
      .then((response) => {
        loadDomains();
      })
      .catch((e) => console.log("error getting deleting domain " + e));
  };

  const openDeleteModal = () => {
    setDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setDeleteModalOpen(false);
  };

  const saveChanges = () => {
    console.log("saving changes");
    DomainService.update(domain.id, domain)
      .then((response) => {
        console.log("saved changes");
        setChangesSaved(true);
        loadDomains();
      })
      .catch((e) => console.log("error getting deleting domain " + e));
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setDomain({ ...domain, [name]: value });
  };

  const closeSaveChangesModal = () => {
    setChangesSaved(false);
  };

  const openGroupsModal = () => {
    setGroupsModalOpen(true);
  };

  const openAddUserModal = () => {
    setUserModalOpen(true);
  };

  const openUsageDataModal = () => {
    setUsageDataModalOpen(true);
  }
  const openUserDetailsModal = () => {
    setUserDetailsModalOpen(true);
  };

  return (
    <>
      <div className="domain-item">
        <div className="domain-clickable" onClick={() => toggleDrop()}>
          <div className="domain-label">
            <span>
              <ChevronRightIcon style={arrowStyle} />
            </span>
            <p>{domain.name}</p>
          </div>
        </div>
        <div className={isDropped ? "domain-content" : "domain-hidden"}>
          <div className="domain-text-field">
            <TextField
              id="outlined-basic"
              defaultValue={domain.name}
              label="Name"
              variant="filled"
              name="name"
              onChange={handleChange}
              fullWidth
            />
          </div>
          <div className="domain-text-field">
            <TextField
              id="outlined-basic"
              defaultValue={domain.webaddress}
              label="Web Address"
              variant="filled"
              name="webaddress"
              onChange={handleChange}
              fullWidth
            />
          </div>

          <div className="domain-buttons">
            <Button
              size="small"
              color="secondary"
              startIcon={<DeleteForeverIcon />}
              style={{ marginLeft: "" }}
              onClick={openDeleteModal}
            >
              Delete Domain
            </Button>
            <CustomYesNoModal
              title={"Are you sure you want to delete " + domain.name + "?"}
              isOpen={isDeleteModalOpen}
              onClose={closeDeleteModal}
              onSubmit={confirmDelete}
              initial={""}
            />
            <Button
              size="small"
              color="primary"
              style={{ marginLeft: "5px" }}
              onClick={saveChanges}
            >
              Save Changes
            </Button>
            <Button
              size="small"
              color="#fff"
              style={{ marginLeft: "5px" }}
              onClick={openGroupsModal}
            >
              See Groups
            </Button>
            <Button
              size="small"
              color="#fff"
              style={{ marginLeft: "5px" }}
              onClick={openUserDetailsModal}
            >
              View Users
            </Button>
            <Button
              size="small"
              color="#fff"
              style={{ marginLeft: "5px" }}
              onClick={openAddUserModal}
            >
              Add User
            </Button>
            <Button
              size="small"
              color="#fff"
              style={{ marginLeft: "5px" }}
              onClick={() => setDeleteUserModalOpen(true)}
            >
              Delete User
            </Button>
            <Button
              size="small"
              color="fff"
              onClick={openUsageDataModal}
            >
              Get Usage Data
            </Button>
            <NotificationModal
              title={"Changes saved!"}
              isOpen={changesSaved}
              onClose={closeSaveChangesModal}
            />
          </div>
        </div>
      </div>
      <GroupsModal
        open={groupsModalOpen}
        onClose={() => setGroupsModalOpen(false)}
        domainId={domain.id}
        domainName={domain.name}
      />
      <UsageDataModal 
        open={usageDataModalOpen}
        onClose={() => setUsageDataModalOpen(false)}
        domainName={domain.name}
        domainId={domain.id}
      />
      {addUserModalOpen && (
        <AddUserToDomainModal
          open={addUserModalOpen}
          onClose={() => setUserModalOpen(false)}
          domainName={domain.name}
          domainId={domain.id}
        />
      )}
      <DeleteUserModal
        open={deleteUserModalOpen}
        onClose={() => setDeleteUserModalOpen(false)}
        domainName={domain.name}
        domainId={domain.id}
      />
      <UserDetailsModal
        open={userDetailsModalOpen}
        onClose={() => setUserDetailsModalOpen(false)}
        domainName={domain.name}
        domainId={domain.id}
      />
    </>
  );
};

export default DomainItem;
